import * as React from 'react';
import App from 'next/app';
import getConfig from 'next/config';
import { Theme } from '@lendi/ui/Theme';
import { Session, Brand, Type, Environment, SessionProvider, SessionRefresh } from '@lendi/lala-react';
import Legal from '@lendi-ui/legal-stuff';
import { CategoryTabs } from '../components/CategoryTabs';
import { DrawerSpacer } from '../components/Drawer/index.style';
import { Header } from '../components/Header';
import { CommPanelProvider } from '@lendi/navbar';
import Footer from '../components/Footer';
import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ? process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID : '',
  clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ? process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN : '',
  site: 'datadoghq.com',
  service: 'inspire-blog',
  env: process.env.ENVIRONMENT,
  sampleRate: 100,
  trackInteractions: true,
  defaultPrivacyLevel: 'mask',
});

const { publicRuntimeConfig = {} } = getConfig() || {};
const { ENVIRONMENT } = publicRuntimeConfig;

let appEnv;
switch (ENVIRONMENT) {
  case 'staging':
    appEnv = Environment.Staging;
    break;
  case 'production':
    appEnv = Environment.Production;
    break;
  case 'preproduction':
    appEnv = Environment.Preproduction;
    break;
  default:
    appEnv = Environment.Development;
}

const session = new Session({
  brand: Brand.Lendi,
  type: Type.Customer,
  environment: appEnv,
});

export default class MyApp extends App {
  render() {
    const { Component, pageProps } = this.props;
    const isArticlePage = Boolean(pageProps.article);

    return (
      <SessionProvider session={session}>
        <SessionRefresh>
          <Theme>
            <CommPanelProvider>
              <Header isArticlePage={isArticlePage} />
              <CategoryTabs categories={pageProps.categories || []} category={pageProps.category} />
              <Component {...pageProps} />
              <Footer />
              <Legal />
              {isArticlePage && <DrawerSpacer />}
            </CommPanelProvider>
          </Theme>
        </SessionRefresh>
      </SessionProvider>
    );
  }
}
